import { createContext, useContext, useState } from "react";

const AuthContext = createContext({
  authUser: null,
  loading: true,
  isAuth: false,
  loadUserSuccess: () => {},
  loadUserFaiture: () => {},
});

export function AuthProvider({ children }) {
  const [isAuth, setIsAuth] = useState(false);
  const [authUser, setAuthUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const loadUserSuccess = (user) => {
    setIsAuth(true);
    setLoading(false);
    setAuthUser(user);
  };

  const loadUserFaiture = () => {
    setIsAuth(false);
    setLoading(false);
    setAuthUser(null);
  };
  const reInitAuth = () => {
    setLoading(true);
  };
  const auth = {
    isAuth,
    authUser,
    loading,
    loadUserSuccess,
    loadUserFaiture,
    reInitAuth,
  };
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
// custom hook to use the authUserContext and access authUser and loading
export const useAuth = () => useContext(AuthContext);
